import { useState, useMemo } from "react";

const allCities = [
  {
    name: "Ewa Beach",
    route: "/ewa-beach",
    tagline: "Leeward Oahu expedited passport processing",
    highlights: ["Ewa Beach area coverage", "Serving Kapolei, Waipahu"],
    badge: null,
  },
  {
    name: "Hilo",
    route: "/hilo",
    tagline: "Big Island East Hawaii expedited passport hub",
    highlights: ["Hilo area coverage", "Serving Pahoa, Keaau, Mountain View"],
    badge: null,
  },
  {
    name: "Honolulu",
    route: "/honolulu",
    tagline: "Oahu's premier expedited passport service",
    highlights: ["24-hour emergency processing available", "Serving Waikiki, Ala Moana, Downtown"],
    badge: "Most Popular",
  },
  {
    name: "Kahului",
    route: "/kahului",
    tagline: "Maui's expedited passport hub",
    highlights: ["Kahului Airport area", "Serving Wailuku, Paia, Makawao"],
    badge: "Most Popular",
  },
  {
    name: "Kailua",
    route: "/kailua",
    tagline: "Windward Oahu expedited passport services",
    highlights: ["Kailua Beach area", "Serving Lanikai, Waimanalo"],
    badge: null,
  },
  {
    name: "Kailua-Kona",
    route: "/kailua-kona",
    tagline: "Big Island West Hawaii expedited passport processing",
    highlights: ["Kona International Airport area", "Serving Kealakekua, Captain Cook"],
    badge: null,
  },
  {
    name: "Kaneohe",
    route: "/kaneohe",
    tagline: "Windward Oahu expedited passport services",
    highlights: ["Kaneohe area coverage", "Serving Kahaluu, Ahuimanu"],
    badge: null,
  },
  {
    name: "Kapaa",
    route: "/kapaa",
    tagline: "Kauai East Side expedited passport services",
    highlights: ["Kapaa area coverage", "Serving Wailua, Anahola"],
    badge: null,
  },
  {
    name: "Kapolei",
    route: "/kapolei",
    tagline: "Leeward Oahu's second city passport services",
    highlights: ["Kapolei area coverage", "Serving Ewa Beach, Waipahu"],
    badge: null,
  },
  {
    name: "Wailea",
    route: "/wailea",
    tagline: "South Maui luxury resort expedited passport services",
    highlights: ["Wailea area coverage", "Serving Kihei, Makena"],
    badge: null,
  },
  {
    name: "Kihei",
    route: "/kihei",
    tagline: "South Maui expedited passport services",
    highlights: ["Kihei area coverage", "Serving Wailea, Makena"],
    badge: null,
  },
  {
    name: "Lahaina",
    route: "/lahaina",
    tagline: "West Maui expedited passport processing",
    highlights: ["Lahaina area coverage", "Serving Kaanapali, Napili"],
    badge: null,
  },
  {
    name: "Kauai",
    route: "/kauai",
    tagline: "Garden Isle island-wide expedited passport services",
    highlights: ["All of Kauai covered", "Serving Lihue, Kapaa, Hanalei, Poipu"],
    badge: null,
  },
  {
    name: "Lihue",
    route: "/lihue",
    tagline: "Kauai's expedited passport hub",
    highlights: ["Lihue Airport area", "Serving Kapaa, Koloa, Kalaheo"],
    badge: null,
  },
  {
    name: "Maui",
    route: "/maui",
    tagline: "Valley Isle island-wide expedited passport services",
    highlights: ["All of Maui covered", "Serving Kahului, Kihei, Lahaina, Hana"],
    badge: null,
  },
  {
    name: "Mililani",
    route: "/mililani",
    tagline: "Central Oahu expedited passport services",
    highlights: ["Mililani area coverage", "Serving Wahiawa, Waipio"],
    badge: null,
  },
  {
    name: "Pearl City",
    route: "/pearl-city",
    tagline: "Leeward Oahu expedited passport processing",
    highlights: ["Pearl City area coverage", "Serving Aiea, Waimalu"],
    badge: null,
  },
  {
    name: "Waikiki",
    route: "/waikiki",
    tagline: "Honolulu's premier expedited passport services",
    highlights: ["Waikiki Beach area", "Serving Ala Moana, Diamond Head"],
    badge: null,
  },
  {
    name: "Wailuku",
    route: "/wailuku",
    tagline: "Central Maui expedited passport services",
    highlights: ["Wailuku area coverage", "Serving Kahului, Waihee"],
    badge: null,
  },
  {
    name: "Waipahu",
    route: "/waipahu",
    tagline: "Leeward Oahu expedited passport processing",
    highlights: ["Waipahu area coverage", "Serving Pearl City, Ewa Beach"],
    badge: null,
  },
  {
    name: "Wahiawa",
    route: "/wahiawa",
    tagline: "Central Oahu expedited passport services",
    highlights: ["Wahiawa area coverage", "Serving Mililani, Schofield"],
    badge: null,
  },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function HawaiiCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Hawaii Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Hawaii Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your island.
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) => (
              <a
                key={i}
                href={city.route}
                className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
              >
                {city.badge && (
                  <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                    {city.badge}
                  </span>
                )}
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                    <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                    <p className="text-gray-400 text-xs">Hawaii</p>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                <ul className="space-y-2 mb-6 flex-1">
                  {city.highlights.map((h, j) => (
                    <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                      {h}
                    </li>
                  ))}
                </ul>
                <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                  View Services{" "}
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </a>
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We cover all major Hawaii islands.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}